<template>
  <div class="Bottom">
    <div @click="$store.commit('app/SET_ABOUT', true)" class="Bottom__about" :class="{ 'is-black': $route.meta.name == 'load' }">
      {{ trans('about') }}
    </div>
    <div class="Bottom__vr" v-if="$root.$agent.vr || forceVrIcon" @click="toggleVr" :class="{ 'is-black': $route.meta.name == 'load' }">
      <svg><use :xlink:href="'#' + require('./sprite/vr.svg').default.id" /></svg>
    </div>
  </div>
</template>

<script>
import Settings from '@/config/Settings'

export default {
  name: 'Bottom',
  translations: {
    fr: { about: 'Préambule' },
    en: { about: 'Preamble' },
  },
  created() {
    this.forceVrIcon = Settings.localAssets
  },
  methods: {
    toggleVr() {
      const scene = document.querySelector('a-scene')
      scene.enterVR()
    }
  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.Bottom
  position fixed
  bottom 0px
  right 0px
  left 0px
  z-index 97

  &__about
    position absolute
    padding 15px
    left 0px
    bottom 0px
    bottom constant(safe-area-inset-bottom)
    bottom env(safe-area-inset-bottom)
    font-family Inknut
    color white
    font-size 14px
    transition color 1s
    cursor pointer
    &:hover
    &:focus
      color #fff
    &.is-black
      color black
    +max-screen(phone)
      font-size 10px
      padding 12px 10px

  &__vr
    cursor pointer
    position absolute
    bottom 15px
    right 30px
    transition opacity 1s, transform 1s
    bottom constant(safe-area-inset-bottom)
    bottom env(safe-area-inset-bottom)
    &.is-black
      svg
        fill black
    +max-screen(phone)
      bottom 2px
      bottom constant(safe-area-inset-bottom)
      bottom env(safe-area-inset-bottom)
      right 10px
    svg
      height 20px
      width 40px
      transition fill 1s
      fill white
      +max-screen(phone)
        height 20px
        width 30px
    &-enter
    &-leave-active
      opacity 0
      transform translateY(100px)


</style>



// WEBPACK FOOTER //
// src/components/bottom/Bottom.vue